<template>
  <div v-if="isDialogVisible" class="suspension-dialog">
    <EdroneFlex class="suspension-dialog-flex" justify-content row unique-id="8dec7968-a440-4986-9204-e757c673fdb5">
      <EdroneFlex
        align-center
        class="suspension-dialog-flex"
        column
        justify-center
        unique-id="f71fd88e-41f7-4195-93c8-ff989276a247"
      >
        <div class="suspension-dialog-content position-relative">
          <EdroneButtonIcon
            v-if="isDev"
            :disabled="false"
            class="position-absolute"
            size="big"
            style="top: 0.5rem; right: 0.5rem; z-index: 1"
            type="plain"
            @click="isClosed = true"
          >
            <font-awesome-icon icon="fa-light fa-xmark" />
          </EdroneButtonIcon>
          <SuspensionAdministrativeMessage v-if="isSuspendedAdministrative" />
          <SuspensionBillingPlanMessage v-if="isSuspendedBillingPlan" />
          <SuspensionTrialExceededMessage v-if="isSuspendedTrialExceeded" />
          <SuspensionOverdueInvoicesMessage v-if="isSuspendedOverdueInvoices" />
        </div>
      </EdroneFlex>
    </EdroneFlex>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import SuspensionTrialExceededMessage from "vue-app/components/Suspension/SuspensionTrialExceededMessage";
import SuspensionBillingPlanMessage from "vue-app/components/Suspension/SuspensionBillingPlanMessage";
import SuspensionAdministrativeMessage from "vue-app/components/Suspension/SuspensionAdministrativeMessage";
import EdroneFlex from "../../../assets/js/ui/EdroneFlex";
import EdroneButtonIcon from "edrone-components/EdroneButtonIcon.vue";
import SuspensionOverdueInvoicesMessage from "vue-app/components/Suspension/SuspensionOverdueInvoicesMessage.vue";

export default {
  name: "MainLayoutSuspensionDialog",
  components: {
    SuspensionOverdueInvoicesMessage,
    EdroneButtonIcon,
    EdroneFlex,
    SuspensionAdministrativeMessage,
    SuspensionBillingPlanMessage,
    SuspensionTrialExceededMessage,
  },
  data() {
    return {
      isDev: window.EDRONE_CONTEXT.user.isDev,
      isClosed: false,
    };
  },
  computed: {
    ...mapGetters("global", [
      "isSuspendedAdministrative",
      "isSuspendedBillingPlan",
      "isSuspendedTrialExceeded",
      "isSuspendedOverdueInvoices",
    ]),
    isDialogVisible() {
      const isSuspended =
        this.isSuspendedAdministrative ||
        this.isSuspendedBillingPlan ||
        this.isSuspendedTrialExceeded ||
        this.isSuspendedOverdueInvoices;

      const onBillingPage = ["/app/account/billing", { name: "PageAccountBilling" }].includes(this.$route.fullPath);
      const onCloseAccountPage = this.$route?.name === "PageCancellation";

      return isSuspended && !onBillingPage && !onCloseAccountPage && !this.isClosed;
    },
  },
};
</script>

<style scoped>
.suspension-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgb(10 10 10 / 83%);
  z-index: 999999999;
}

.suspension-dialog-flex {
  width: 100%;
  height: 100%;
}

.suspension-dialog-content {
  margin: 0 auto;
  width: 90%;
}

@media screen and (min-width: 56.25rem) {
  .suspension-dialog-content {
    width: 70%;
  }
}

@media screen and (min-width: 75rem) {
  .suspension-dialog-content {
    width: 50%;
  }
}
</style>
